import { migration as initial } from "./001_initial";
import { migration as valuationSnapshot } from "./002_valuation_snapshot";
import { migration as valuationGlTracking } from "./003_valuation_gl_tracking";
import { migration as inventoryClose } from "./004_inventory_close";
import { migration as procurementLandedCost } from "./005_procurement_landed_cost";
import { migration as stockMovementControls } from "./006_stock_movement_controls";
import { migration as inventoryValuationStatusAlignment } from "./007_inventory_valuation_status_alignment";
export const migrations = [
  initial,
  valuationSnapshot,
  valuationGlTracking,
  inventoryClose,
  procurementLandedCost,
  stockMovementControls,
  inventoryValuationStatusAlignment,
];
